// extracted by mini-css-extract-plugin
export default {"badge":"WCb5RETrrYKDLaVPn1d1","plainValue":"uxoZ4y3OFGEmA8PmJTSu"};